import { createContext, useContext } from "react";
import { ActivityBriefDto } from "@growth-machine-llc/stridist-api-client";

export const ActivityContext = createContext<ActivityBriefDto | undefined>(undefined);

export const useActivityContext = () => useContext(ActivityContext);
